import React from "react";
import useProjectCreationContext from "../context/use-project-creation-context.ts";
import SimpleLoadingIndicator from "@/components/simple-loading-indicator";

const CreateProjectProcessingStep: React.FC = () => {
    const { isCreatingProject, creatingProjectPhase } = useProjectCreationContext();

    if(isCreatingProject && typeof creatingProjectPhase === 'string')
        return <SimpleLoadingIndicator orientation={'vertical'} text={creatingProjectPhase} />

    return (
        <div className='flex flex-1 h-full items-center justify-center'>
            {creatingProjectPhase}
        </div>
    )
}

export default CreateProjectProcessingStep;